import { toSaoPauloDateString } from '../../utils/datetime';

export const PERIOD_TODAY = '0';
export const PERIOD_CUSTOM = 'custom';

export const PERIODS = [
  { value: '0', label: 'Hoje' },
  { value: '7', label: 'Últimos 7 dias' },
  { value: '30', label: 'Últimos 30 dias' },
  { value: '90', label: 'Últimos 90 dias' },
];

export function periodToDays(period) {
  return parseInt(period, 10) || 0;
}

export function isTodayPeriod(period) {
  return periodToDays(period) === 0;
}

export function periodToRange(period, now = new Date()) {
  const endDate = toSaoPauloDateString(now);
  const days = periodToDays(period);
  const startDate = days === 0
    ? endDate
    : toSaoPauloDateString(new Date(now.getTime() - days * 86400000));
  return { startDate, endDate };
}
